var map = {
	"./icons/datatable/sort_asc": 57,
	"./icons/datatable/sort_asc.png": 57,
	"./icons/datatable/sort_both": 58,
	"./icons/datatable/sort_both.png": 58,
	"./icons/datatable/sort_desc": 59,
	"./icons/datatable/sort_desc.png": 59,
	"./icons/typing": 60,
	"./icons/typing.gif": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;